import React from "react";
import { useTranslation } from "react-i18next";

/**
 * PageHeader — ส่วนหัวของหน้า AddBuilding ทุกหน้า
 * แสดงปุ่มย้อนกลับ, ชื่อหน้า, และคำอธิบายใต้ชื่อ
 *
 * Props:
 *  - title    : string  — ชื่อหน้า (เช่น "ระบุแผนที่อาคารภายนอก")
 *  - subtitle : string  — คำอธิบาย (ถ้าไม่ส่งจะใช้ค่า default)
 *  - onBack   : func    — callback เมื่อกดปุ่มย้อนกลับ (optional)
 */
export default function PageHeader({
  title,
  subtitle,
  onBack,
  titleClassName = "text-3xl font-black",
}) {
  const { t } = useTranslation();
  const displaySubtitle = subtitle !== undefined ? subtitle : t("admin.addBuilding.defaultSubtitle");

  return (
    <div className="mb-6">
      {/* แถวชื่อหน้า + ปุ่มย้อนกลับ */}
      <div className="flex items-center gap-2 text-slate-900">
        <button
          onClick={onBack}
          className="p-2 rounded-lg text-3xl hover:bg-slate-100"
          aria-label={t("common.back")}
        >
          ‹
        </button>
        <h1 className={titleClassName}>{title}</h1>
      </div>

      {/* คำอธิบายใต้ชื่อหน้า */}
      <p className="p-1 -mt-3 text-sm text-slate-700">{displaySubtitle}</p>
    </div>
  );
}
